export const environment = {
  production: false,
  apiUrl: '/testserver/api',
  version : "1.0.0"
};
